module.exports = __webpack_public_path__ + "img/921_page_rebuild2.027c6bb6.png";